import AnamneseRepository from '@/shared/http/repositories/socialProject/anamnese'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewAnamnese from '../components/anamnese.vue'
import Anamnese from '@/shared/models/anamnese'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'NovaAnamnese',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewAnamnese.name]: NewAnamnese
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Grupo de Anamnese',
    anamnese: new Anamnese(),
    isNew: true
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Grupos de anamnese',
            href: this.$router.resolve({ name: 'Anamnese' }).href
          },
          {
            text: 'Novo grupo de anamnese',
            active: true
          }
        ]
      }
    }
  },

  methods: {
    create(anamnese) {
      loading.push()
      AnamneseRepository.Create(anamnese)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()
    
          loading.pop()
          toast.success('Grupo de anamnese criado com sucesso', 'NOVA ANAMNESE')
          Promise.resolve()
          return this.$router.replace({ name: 'Anamnese' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao criar grupo de anamnese', 'ERRO')
        })
    }
  }
}
